<template>
  <div class="box flex-stretch">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="exporting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Exporting, please wait
        </div>
      </div>
    </div>
    <div class="box-content flex-stretch relative">
      <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8; z-index: 6; min-width: 400px; border-radius: 15px;" v-show="filtering"></div>
      <div class="flex justify-end mb-3">
        <div>
          <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open, data_mode_menu_open = false, reports_menu_open = false">
            <div class="multi-select-input-placeholder">
              Filter...
              <div class="dropdown-icon">
                <i class="fal fa-chevron-down"></i>
              </div>
            </div>
            <div class="multi-select-input-inner" v-show="filter_dropdown_open" @click.stop>
              <div class="multi-select-input-group">
                <h1 class="input-group-title">Date</h1>
                <div class="checkboxes">
                  <div class="" @click.stop>
                    <div class="input-group">
                      <div class="input-group-addon" style="width: 60px;">From:</div>
                      <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                    </div>
                    <div class="input-group mt-1">
                      <div class="input-group-addon" style="width: 60px;">To:</div>
                      <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Enquiry Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="enquiry_type in all_enquiry_types">
                    <label>
                      <input type="checkbox" name="status" :value="enquiry_type.id" v-model="enquiry_type_filter">
                      <span class="checkbox-label">{{ enquiry_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Company Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="company_type in all_company_types">
                    <label>
                      <input type="checkbox" name="company_types" :value="company_type.id" v-model="selected_company_types">
                      <span class="checkbox-label">{{ company_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-3">
          <div class="btn-dropdown" :class="{ '_open' : data_mode_menu_open }" @click.stop="data_mode_menu_open = !data_mode_menu_open, filter_dropdown_open = false, reports_menu_open = false">
            <div class="btn-primary">
              Show As:
              <i class="fal fa-chevron-up" v-if="data_mode_menu_open"></i>
              <i class="fal fa-chevron-down" v-if="!data_mode_menu_open"></i>
            </div>
            <div class="btn-dropdown-menu" @click.stop>
              <a @click.stop="data_mode = 'table', data_mode_menu_open = false" class="cursor-pointer">
                <i class="fal fa-check" v-if="data_mode === 'table'"></i>
                Table
              </a>
              <a @click.stop="data_mode = 'pie', data_mode_menu_open = false" class="cursor-pointer">
                <i class="fal fa-check" v-if="data_mode === 'pie'"></i>
                Pie Chart
              </a>
            </div>
          </div>
        </div>
        <div class="ml-3">
          <a class="btn-primary" @click.stop.prevent="exportSpreadsheet()">
            Export
          </a>
        </div>
        <div class="ml-3">
          <reports-menu :menu_open="reports_menu_open" @open="reports_menu_open = true, filter_dropdown_open = false, data_mode_menu_open = false" @close="reports_menu_open = false"></reports-menu>
        </div>
      </div>
      <div id="reports-enquiries-piechart" class="flex-stretch" v-show="data_mode === 'pie'"></div>
      <div id="reports-enquiries-table" class="google-table-wrapper flex-stretch" v-show="data_mode === 'table'"></div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  async mounted() {
    let lastYear = new Date();
    lastYear.setFullYear(lastYear.getFullYear() - 1);
    this.date_filter_start = lastYear;

    window.googleCharts.charts.load('current', {
      'packages': ['table', 'corechart']
    });

    this.loadEnquiryTypesList();
    this.loading = false;
  },
  props: [
      'all_enquiry_types',
      'all_company_types',
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      filtering: false,
      date_filter_start: null,
      date_filter_end: new Date(),
      enquiries_list: [],
      loading: true,
      filter_dropdown_open: false,
      enquiry_type_filter: [],
      enquiry_types: [],
      enquiry_pie_data: [],
      data_mode: 'table',
      data_mode_menu_open: false,
      reports_menu_open: false,
      selected_company_types: [],
      exporting: false,
    }
  },
  methods: {
    drawPie() {
      let header_data = [['Enquiry Type', 'Enquiries']];
      let pie_data = header_data.concat(this.enquiry_pie_data);

      let data = window.googleCharts.visualization.arrayToDataTable(pie_data);

      let options = {
        title: 'Enquiries'
      };

      let chart = new window.googleCharts.visualization.PieChart(document.getElementById('reports-enquiries-piechart'));

      chart.draw(data, options);
    },
    drawTable() {
      let data = new window.googleCharts.visualization.DataTable();

      let data_rows = [];
      let total_enquiries = 0;

      let enquiry_type_total_count = [];

      this.enquiry_types.forEach(function(){
        enquiry_type_total_count.push(0);
      });

      Object.values(this.enquiries_list).forEach(function(enquiry_date) {
        let rows = [enquiry_date.date, enquiry_date.total_enquiries];
        let enquiry_type_data_rows = [];
        total_enquiries = total_enquiries + enquiry_date.total_enquiries;
        enquiry_date.enquiry_types.forEach(function(enquiry_type) {
          enquiry_type_data_rows.push(enquiry_type.enquiry_count);
        });
        enquiry_type_total_count = enquiry_type_total_count.map((count, index) => count + enquiry_type_data_rows[index]);
        let all_rows = rows.concat(enquiry_type_data_rows);
        data_rows.push(all_rows);
      });

      data.addColumn({type: 'string', label: 'Date', p: {className: 'date-column'}});
      data.addColumn('number', `Total Enquiries (${total_enquiries})`);

      this.enquiry_types.forEach(function(enquiry_type, index){
        data.addColumn('number', `${enquiry_type.label} (${enquiry_type_total_count[index]})`);
      });

      data.addRows(data_rows);

      let table_wrapper = document.getElementById('reports-enquiries-table');
      let table_wrapper_height = table_wrapper.offsetHeight - 1;
      let table_wrapper_width = table_wrapper.offsetWidth - 1;
      let table = new window.googleCharts.visualization.Table(table_wrapper);
      table.draw(data, {showRowNumber: false, width: table_wrapper_width, height: table_wrapper_height, frozenColumns: 1,});
    },
    loadEnquiriesList: _.debounce(function () {
      axios.post('/reports/getEnquiryData', {
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        enquiry_type_filter: this.enquiry_type_filter,
        selected_company_types: this.selected_company_types,
      }).then((response) => {
        this.enquiries_list = response.data;
        this.filtering = false;
        window.googleCharts.charts.setOnLoadCallback(this.drawTable);
      });
    }, 250),
    loadEnquiryTypesList: _.debounce(function () {
      axios.post('/reports/getEnquiryTypes', {
        enquiry_type_filter: this.enquiry_type_filter,
      }).then((response) => {
        this.enquiry_types = response.data;

        if (this.data_mode === 'pie') {
          this.loadEnquiryPieData();
        }

        if (this.data_mode === 'table') {
          this.loadEnquiriesList();
        }

      });
    }, 250),
    loadEnquiryPieData: _.debounce(function () {
      axios.post('/reports/getEnquiryPieData', {
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        enquiry_type_filter: this.enquiry_type_filter,
        selected_company_types: this.selected_company_types,
      }).then((response) => {
        this.enquiry_pie_data = response.data;
        this.filtering = false;
        window.googleCharts.charts.setOnLoadCallback(this.drawPie);
      });
    }, 250),
    exportSpreadsheet() {
      this.exporting = true;
      axios({
        url: '/reports/export/enquiries',
        method: 'POST',
        responseType: 'blob',
        data: {
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
          enquiry_type_filter: this.enquiry_type_filter,
          selected_company_types: this.selected_company_types,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reports_enquiries.xlsx');
        document.body.appendChild(link);
        link.click();
        this.exporting = false;
      });
    },
  },
  watch: {
    date_filter_start() {
      this.filtering = true;
      this.loadEnquiryTypesList();
    },
    date_filter_end() {
      this.filtering = true;
      this.loadEnquiryTypesList();
    },
    enquiry_type_filter() {
      this.filtering = true;
      this.loadEnquiryTypesList();
    },
    data_mode() {
      this.filtering = true;
      this.loadEnquiryTypesList();
    },
    selected_company_types() {
      this.filtering = true;
      this.loadEnquiryTypesList();
    },
  },
};
</script>
